import { render, staticRenderFns } from "./user-manag.vue?vue&type=template&id=1b9f1fab&"
import script from "./user-manag.vue?vue&type=script&lang=js&"
export * from "./user-manag.vue?vue&type=script&lang=js&"
import style0 from "./user-manag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports